import { IKnmType } from 'APIPackage/CatalogsModule/interfaces/IKnmType';

export const createKnmTypeSelectOption = (knmType: IKnmType) => ({
  ...knmType,
  label: knmType.name,
  value: knmType.code,
});
